<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :before-close="handleCancle"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal="false"
        :modal-append-to-body="false"
        width="370px"
        title="添加标签"
        class="kbs-add-label-dialog"
    >
        <el-row class="kbs-tag-container kbs-label clearfix">
            <el-col class="kbs-chose">选择标签：</el-col>
            <el-col class="kbs-chose-tags">
                 <el-tag
                    :class="item.checked?'kbs-tag-checked':''"
                    v-for="item in labelList"
                    :key="item.id"
                    @click="handleTagChecked($event, item)"
                >{{ item.name }}<i v-if="item.checked" class="iconfont iconchecked"></i></el-tag>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleCancle">取 消</el-button>
            <el-button type="primary" size="small" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { getAllLabelList } from '@/api/crm/widgets'
export default {
  props: {
    checkedLabelIds: {
      require: true,
      type: Array,
      // eslint-disable-next-line no-unused-expressions
      default: () => { [] }
    }
  },
  data() {
    return {
      dialogVisible: true,
      labelList: []
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      getAllLabelList().then(res => {
        this.labelList = res.data
        this.labelList.forEach(label => {
          if (this.checkedLabelIds.includes(label.id)) {
            label.checked = true
          } else {
            label.checked = false
          }
        })
      })
    },
    handleConfirm() {
      this.$emit('closeAddLabelModel', this.labelList)
    },
    handleCancle() {
      this.$emit('closeAddLabelModel')
    },
    handleTagChecked(e, tag) {
      this.labelList.forEach(item => {
        if (item.id === tag.id && item.checked === false) {
          this.$set(item, 'checked', true)
        } else if (item.id === tag.id && item.checked === true) {
          this.$set(item, 'checked', false)
        }
      })
      this.$forceUpdate()
      // console.log('this.labelList', this.labelList)
    }
  }
}
</script>
<style lang="scss">
.kbs-add-label-dialog .el-dialog__header{
  padding: 15px 20px 15px;
  border-bottom: 1px solid #DCDFE6;
  font-size: 16px;
}
.kbs-add-label-dialog .el-dialog__body{
  padding: 20px;
}
.kbs-add-label-dialog .el-dialog__footer{
  padding-top: 20px !important;
    text-align: center;
    .el-button{
      width: 80px;
      height: 30px;
      padding: 0px 20px;
    }
}
</style>
<style lang="scss" scoped>
.el-dialog__wrapper{
  position: absolute;
}
.kbs-label.kbs-tag-container{
    .kbs-chose {
        display: inline-block !important;
        vertical-align: top;
        line-height: 28px;
        width: 80px;
        font-weight: 700;
    }
    .kbs-chose-tags {
        position: relative;
        display: inline-block !important;
        width: calc(100% - 80px);
        height: 90px;
        padding-top: 5px;
        overflow: auto;
        .el-tag.kbs-tag-checked{
            background-color: #337DFF;
            color: #fff;
        }
        .el-tag{
            color: #666;
            position: relative;
            cursor: pointer;
            display: inline-block;
            text-align: right;
            // position: relative;
            height: 24px;
            margin: 3px 12px 2px 0;
            padding: 0px 10px;
            line-height: 20px;
            border: none;
            .iconchecked{
                position: absolute;
                top: -9px;
                right: -9px;
                color: #FEA903;
                font-size: 13px;
            }
        }
    }
}
</style>
